import { Link } from "react-router-dom";

interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryLabel?: string;
  secondaryPath?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  secondaryLabel,
  secondaryPath,
}: EmptyStateProps) {
  return (
    <div className="w-full py-16 md:py-20 px-4 rounded-lg border border-dashed border-background-300 bg-background-100/60 flex flex-col items-center text-center">
      <div className="w-14 h-14 rounded-full bg-background-200 flex items-center justify-center mb-4">
        <i className="ri-film-line text-xl text-foreground-500 w-6 h-6 flex items-center justify-center"></i>
      </div>
      <h3 className="font-heading text-lg text-foreground-900">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-600 max-w-[420px]">{description}</p>}
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="h-9 px-4 rounded-md bg-primary-600 text-background-50 text-sm whitespace-nowrap hover:bg-primary-700 transition-colors cursor-pointer"
          >
            {actionLabel}
          </button>
        )}
        {secondaryLabel && secondaryPath && (
          <Link
            to={secondaryPath}
            className="h-9 px-4 inline-flex items-center rounded-md border border-background-300 text-sm text-foreground-700 whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors"
          >
            {secondaryLabel}
          </Link>
        )}
      </div>
    </div>
  );
}